import React from 'react';
import {executeQuery} from "../../requests/executeQuery";
import {HSC_PIPELINE_FEES} from "../../consts/queries";
import {HscPipelineFeesModel, HscPipelineFeesTotals} from "./hscPipelineFeesModel";
import {columns, totalColumns} from "./columns";
import PipelineTable from "../PipelineTable";
import {startYear} from "../../consts/consts";
import {formatPipelineTitle} from "../../utils";

export default class HscPipelineFees extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            rows: {},
            loading: false,
            totals: {},
            title: 'Closed',
        }
    }

    componentDidMount() {
        this.fetch(this.props.routeParams.id);
    }

    fetch(id) {
        this.setState({loading: true});

        let year = id && id.split('-')[1] !== 'ytd' ? id.split('-')[1] : new Date().getFullYear();
        let y = year;
        const requests = [
            executeQuery({
                queryName: HSC_PIPELINE_FEES,
                params: {
                    HSC_STATUS: 'Closed',
                    YEAR: year,
                }
            }),
        ];

        while(y > startYear) {
            requests.push(executeQuery({
                queryName: HSC_PIPELINE_FEES,
                params: {
                    HSC_STATUS: 'Closed',
                    YEAR: --y,
                }
            }));
        }

        Promise.all(requests).then(res => {
            const state = {
                loading: false,
                title: formatPipelineTitle(id),
                rows: [],
                totals: [],
            };

            if (res && res[0] && res[0].success && Array.isArray(res[0].data) && res[0].data.length) {
                res[0].data.map((row, index) => {
                    const previousCumulative = index > 0 ? state.rows[index-1].cumulative : 0;
                    state.rows.push(new HscPipelineFeesModel({data: row, previousCumulative}));
                });
                state.rows.push(new HscPipelineFeesModel({data: state.rows, isTotal: true, year}));
            }

            state.totals.push(new HscPipelineFeesTotals({data: state.rows, year, isCurrentYear: true}));
            for (let index = 1; index < res.length; index++) {
                if (res[index] && res[index].data)
                    state.totals.push(new HscPipelineFeesTotals({data: res[index].data, year: --year}));
            }
            state.totals.push(new HscPipelineFeesTotals({data: state.totals, isTotal: true}));
            this.setState(state);
        });
    }

    render() {
        const {rows, totals, loading, title} = this.state;

        return (
            <div className='HscPipelineFees'>
                <h3 className='h3'>{title}</h3>
                {
                    loading ?
                        <div className='loading'>Loading data...</div>
                        :
                        <React.Fragment>
                            <PipelineTable rows={rows} columns={columns} hasTotalRow={true} className='list'/>
                            <PipelineTable rows={totals} columns={totalColumns} hasTotalRow={true} className='totals'/>
                        </React.Fragment>
                }
            </div>
        );
    }
}